import {ParseResult} from './markdown';
import {blockPluginNames} from './plugins';

export type MarkdownTag = {
	pattern: RegExp;
	content?: (match: RegExpMatchArray) => string;
	tmp?: (match: RegExpMatchArray) => any;
	type: ((match: RegExpMatchArray) => string) | string;
};

let blockLine: RegExp | undefined;

/**
 * Строка целиком из блочного плагина: такую нельзя заворачивать в <p> — плагин рисует карточку.
 * Какие плагины блочные, объявляют они сами; выражение строится при первом обращении, потому что
 * на момент загрузки модуля плагины могут быть ещё не готовы. Аргументов может и не быть —
 * `{@currentLairsEffects}`.
 */
export function isBlockPluginLine(text: string): boolean {
	if (!blockLine) {
		blockLine = new RegExp('^\\s*\\{@(?:' + blockPluginNames().join('|') + ')(?:\\s[^}]*)?\\}\\s*$');
	}
	return blockLine.test(text);
}

const blockTags: MarkdownTag[] = [
	{
		pattern: /^\s*(#{1,6})\s+(.*)/g,
		content: (match: RegExpMatchArray) => match[2],
		type: (match: RegExpMatchArray) => `h${match[1].length}`,
	},
	{
		pattern: /^\s*\*\s+(.*)/g,
		content: (match: RegExpMatchArray) => match[1],
		type: 'unorderedListItem',
	},
	{
		pattern: /^\s*[0-9]+\.\s+(.*)/g,
		content: (match: RegExpMatchArray) => match[1],
		type: 'orderedListItem',
	},
	{
		pattern: /^\s*(&gt;&gt;|>>)\s*(.*?)$/g,
		type: 'blockquoteAuthor',
		content: (match: RegExpMatchArray) => match[2],
	},
	{
		pattern: /^\s*(&gt;|>)\s*(.*?)$/g,
		type: 'blockquoteChild',
		content: (match: RegExpMatchArray) => match[2],
	},
	{
		type: 'tableMeta',
		pattern: /^\s*\|(\s*:?-{1,}:?\s*\|)+/g,
		tmp: (match: RegExpMatchArray) => {
			return match[0]
				.trim()
				.split('|')
				.map((s) => s.trim())
				.filter(Boolean)
				.map((s) => {
					let align = 'Left';
					if (s.at(0) === ':' && s.at(-1) === ':') align = 'Center';
					else if (s.at(-1) === ':') align = 'Right';
					s = s.replace(/:/g, '');
					return {align, length: s.length};
				});
		},
	},
	{
		type: 'tableRow',
		pattern: /^\s*\|(\s*(.*?)\s*\|)+/g,
		tmp: (match: RegExpMatchArray) => {
			const parts = match[0].trim().split('|').map((s) => s.trim());
			if (parts.length > 0 && parts[0] === '') parts.shift();
			if (parts.length > 0 && parts[parts.length - 1] === '') parts.pop();
			return parts;
		},
	},
];

export function parseBlockTags(text: string): ParseResult {
	if (isBlockPluginLine(text)) return {tag: 'blockPlugin', content: text.trim()};

	for (let meta of blockTags) {
		const match = [...text.matchAll(meta.pattern)];
		if (match && match[0]) {
			return {
				tag: typeof meta.type === 'string' ? meta.type : meta.type(match[0]),
				content: meta.content ? meta.content(match[0]).trim() : undefined,
				tmp: meta.tmp ? meta.tmp(match[0]) : undefined,
			};
		}
	}

	return {
		tag: 'p',
		content: text.trim(),
	};
}
